import { NgModule } from '@angular/core';
import { MonValidUrlDirective } from './validators/valid-domain.directive';
import { MultiEmailValidatorDirective } from './validators/multi-email-validator.directive';

@NgModule({
    declarations: [MonValidUrlDirective, MultiEmailValidatorDirective],
    exports: [MonValidUrlDirective, MultiEmailValidatorDirective],
})
export class MonsidoDirectiveModule {}
